import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import configs, { getParameterByName } from '../Constants';


// Create the context
const UserPermissionsContext = createContext();

// Custom hook to use the context
export const useUserPermissions = () => {
  const context = useContext(UserPermissionsContext);
  if (!context) {
    throw new Error('useUserPermissions must be used within a UserPermissionsProvider');
  }
  return context;
};

export const UserPermissionsProvider = ({ children }) => {
  const [userPermissions, setUserPermissions] = useState({});
  const [userSevicePacks, setUserSevicePacks] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const url_token = getParameterByName("token");
  let userToken = url_token ? url_token : sessionStorage.getItem("token");
  let tokenUrl = configs.authapi + "/user/validate-token";
  let baseURL = configs.baseURL;
  if (url_token) {
    sessionStorage.setItem("token", userToken);
    window.location.href = window.location.origin + "/";
  }

  const updateUserMolulesAndPermisions = (userData) => {
    const userRole = userData.role;
    const userId = userData.sub;
    const token = sessionStorage.getItem("token");
    const authApiServer = configs.authapi;

    // Check if user is admin or equivalent role using helper
    const isAdmin = !userData.isIAM;
    let servicePack = userData.plan && userData.plan.services && JSON.parse(userData.plan.services);
    console.log(servicePack);
    setUserSevicePacks(servicePack);
    // Set full permissions for admin users
    setUserPermissions({
      // Category permissions
      IS_CATEGORY_CREATE: true,
      IS_CATEGORY_EDIT: true,
      IS_CATEGORY_DELETE: true,
      IS_CATEGORY_VIEW: true,

      // Inventory permissions
      IS_INVENTORY_VIEW: true,
      IS_INVENTORY_CREATE: true,
      IS_INVENTORY_EDIT: true,
      IS_INVENTORY_DELETE: true,

      // Promotion permissions
      IS_PROMOTION_VIEW: true,
      IS_PROMOTION_CREATE: true,
      IS_PROMOTION_EDIT: true,
      IS_PROMOTION_DELETE: true,

      // Kitchen permissions
      IS_KITCHEN_VIEW: true,
      IS_KITCHEN_CREATE: true,
      IS_KITCHEN_EDIT: true,
      IS_KITCHEN_DELETE: true,

      // Variety permissions
      IS_VARIETY_VIEW: true,
      IS_VARIETY_CREATE: true,
      IS_VARIETY_EDIT: true,
      IS_VARIETY_DELETE: true,

      // Customer permissions
      IS_CUSTOMER_VIEW: true,
      IS_CUSTOMER_ADD: true,
      IS_CUSTOMER_EDIT: true,
      IS_CUSTOMER_DELETE: true,

      // Tables permissions
      IS_TABLES_VIEW: true,
      IS_TABLES_CREATE: true,
      IS_TABLES_EDIT: true,
      IS_TABLES_DELETE: true,
      IS_TABLES_TOGGLE: true,

      // Order permissions
      IS_ORDERS_VIEW: true,
      IS_ORDERS_EDIT: true,
      IS_ORDERS_STATUS_CHANGE: true,
      IS_ORDERS_PAYMENT: true,
      IS_ORDERS_CANCEL: true,

      // Reports permissions
      IS_REPORTS_VIEW: true,
      IS_REPORTS_EXPORT: true,

      // Other permissions
      IS_ITEMS_VIEW: true,
      IS_POS_VIEW: true,
      IS_MEMBER_VIEW: true,
      IS_QR_CODES_VIEW: true,
      IS_NOTIFICATION_VIEW: true,
      IS_CMS_VIEW: true,
      IS_APPS_VIEW: true
    });
    setIsLoading(false);

  }

  useEffect(() => {
    const fetchUserPermissions = async () => {
      try {
        setIsLoading(true);
        console.log(localStorage.getItem("userData"));
        let userData = localStorage.getItem("userData")
          ? JSON.parse(localStorage.getItem("userData"))
          : null;
        if (!userData && userToken && userToken.length > 40) {

          axios({
            method: "post",
            url: tokenUrl,
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          })
            .then((res) => {
              console.log("user token details", res.data.user);
              if (res.data.user) {
                setIsLoading(false);
                localStorage.setItem("userData", JSON.stringify(res.data.user));
                //userData = res.data.user;
                window.location.reload();
              }

            })
            .catch((err) => {
              console.error(err);
            });
        } else {
          updateUserMolulesAndPermisions(userData);
        }




      } catch (error) {
        console.error("Error fetching user permissions:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserPermissions();
  }, []);

  return (
    <UserPermissionsContext.Provider value={{ userPermissions, userSevicePacks, isLoading }}>
      {children}
    </UserPermissionsContext.Provider>
  );
};

export default UserPermissionsContext;